import * as yup from "yup";

const validateImageFile = (file) => {
  console.log(file, " this is file");
  const allowedExtensions = ["jpg", "jpeg", "png", "svg"]; // Add more extensions as needed
  console.log(
    file[0]?.name?.split(".").pop().toLowerCase(),
    " this is file type"
  );
  let fileExtension;
  if (file[0]?.name) {
    fileExtension = file[0]?.name?.split(".").pop().toLowerCase();
  } else {
    fileExtension = file?.split(".").pop().toLowerCase();
    console.log(
      file?.split(".").pop().toLowerCase(),
      " if file[0] is undefined"
    );
  }
  console.log(
    allowedExtensions.includes(fileExtension),
    " allowedExtensions.includes(fileExtension)"
  );
  return allowedExtensions.includes(fileExtension);
};

export const emailValidation = yup.object().shape({
  email: yup
    .string()
    .trim()
    .required("Email Address is required")
    .email("Please enter a valid email Address"),
});

export const currentPasswordNewPasswordValidation = yup.object().shape({
  currentPassword: yup.string().trim().required("Current password is required"),
  newPassword: yup
    .string()
    .trim()
    .required()
    .matches(
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/,
      "Password must contain at least 8 characters, one uppercase letter, one lowercase letter, one number, and one special character"
    ),
});

export const loginEmailAndPasswordValidation = yup.object().shape({
  email: yup
    .string()
    .trim()
    .required("Email is required")
    .email("Invalid Email"),
  password: yup.string().trim().required("Password is required"),
  rememberMe: yup.boolean(),
});

//Employer Login Validation
export const userValidationSchema = yup.object().shape({
  full_name: yup.string().required("Name is required"),
  user_type: yup.string().required("User Type is required"),
  email_address: yup
    .string()
    .required("Email Address is required")
    .email("Please enter a valid email Address"),
  password: yup.string().required("Password is required"),
});

export const MobileNumberValidationSchema = yup.object().shape({
  mobile_number: yup.string().required("Mobile Number is required"),
});

const tradeSchema = yup.object().shape({
  id: yup.string().required(),
  label: yup.string().required(),
});

export const CreatePartnerValidationSchema = yup.object().shape({
  name_of_institute: yup
    .string()
    .matches(
      /^[a-zA-Z\s]*$/,
      "Name of institute must contain only alphabetic characters"
    )
    .trim()
    .required("Name of Institute is required"),
  contact_number: yup
    .string()
    .required("Contact Number is required")
    .matches(/^[0-9]{10}$/, "Contact Number must be exactly 10 digits")
    .test("valid-mobile", "Invalid Contact Number", (value) => {
      return value ? true : false;
    }),
  contact_email_address: yup
    .string()
    .email("Invalid email format")

    .matches(
      /^[a-zA-Z0-9._\-+]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/i,
      "Invalid email format"
    )
    .required("Email Address is required"),
  alternate_contact_number: yup
    .string()
    .trim()
    .matches(/^[0-9]{10}$/, "Contact Number must be exactly 10 digits")
    .test("valid-mobile", "Invalid Contact Number", (value) => {
      if (!value) return true;
      return value ? true : false;
    }),
  alternate_email_address: yup
    .string()
    .email("Invalid email format")
    .matches(
      /^[a-zA-Z0-9._\-+]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/i,
      "Invalid email format"
    )
    .optional("Email Address is required"),
  trade: yup
    .array()
    .of(tradeSchema)
    .required("Training Trade is required")
    .min(1, "At least one trade is required"),
  institute_type: yup.string().trim().required("Institute Type is required"),
  contact_person_first_name: yup
    .string()
    .matches(
      /^[a-zA-Z\s]*$/,
      "First name must contain only alphabetic characters"
    )
    .trim()
    .required("Please enter first name"),
  contact_person_middle_name: yup
    .string()
    .matches(
      /^[a-zA-Z\s]*$/,
      "Middle name must contain only alphabetic characters"
    )
    .trim()
    .optional(),
  contact_person_last_name: yup
    .string()
    .matches(
      /^[a-zA-Z\s]*$/,
      "Last name must contain only alphabetic characters"
    )
    .trim()
    .required("Please enter last name"),
  address: yup.string().trim().required("Address is required"),
  pincode: yup
    .string()
    .trim()
    .required("Pincode is required")
    .matches(/^\d{6}$/, "Pincode must be exactly 6 digits"),
  city: yup.string().trim().required("City is required"),
  state: yup.string().trim().required("State is required"),
});


export const CreateCandidateValidationSchema = yup.object().shape({
  user_name: yup
    .string()
    .required("User Name is required")
    .matches(
      /^[a-zA-Z\s]*$/,
      "User name must contain only alphabetic characters"
    )
    .trim(),
  mobile_number: yup
    .string()
    .required("Mobile Number is required")
    .matches(/^[0-9]{10}$/, "Mobile Number must be exactly 10 digits")
    .test("valid-mobile", "Invalid Mobile Number", (value) => {
      if (!value) return false;
      return !["0000000000", "1111111111", "2222222222", "3333333333", "4444444444", "5555555555", "6666666666", "7777777777", "8888888888", "9999999999"].includes(value);
    }),
  email: yup
    .string()
    .email("Invalid email format")
    .matches(
      /^[a-zA-Z0-9._\-+]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/i,
      "Invalid email format"
    )
    .required("Email is required"),
  gender: yup
    .string()
    .required("Gender is required"),
  dob: yup
    .date()
    .required("Date of birth is required")
    .max(
      new Date(new Date().setFullYear(new Date().getFullYear() - 18)),
      "Date of birth must be at least 18 years before the current date"
    ),
  pincode: yup
    .string()
    .required("Pincode is required")
    .matches(/^[0-9]{6}$/, "Pincode must be exactly 6 digits"),
  past_work_experience: yup
    .number()
    .required("Past work experience is required")
    .min(0, "Experience cannot be negative")
    .typeError("Past work experience must be a number"),
  job_expertise: yup
    .array()
    .min(1, "At least one job expertise is required")
    .required("Job expertise is required"),
  expectedSalary: yup
    .string()
    .required("Expected salary is required"),
  education_information: yup
    .array()
    .min(1, "At least one educational qualification is required")
    .required("Educational information is required"),
  // language: yup
  //   .array()
  //   .min(1, "At least one language is required")
  //   .required("Language is required"),
});

export const CandidateKycValidationSchema = yup.object().shape({
  first_name: yup.string().required("First Name is required"),
  state: yup.string().required("State is required"),
  jobshayakName: yup.string().required("Jobsahayak is required"),
});

export const CreateEmployerValidationSchema = yup.object().shape({
  companyName: yup.string().trim().required("Company Name is required"),
  firstName: yup.string().trim().required("First Name is required"),
  // middleName: yup.string().trim().required('Middle Name is required'),
  lastName: yup.string().trim().required("Last Name is required"),
  phone: yup
    .string()
    .required("Contact Number is required")
    .matches(/^[0-9]{10}$/, "Contact Number must be exactly 10 digits")
    .test("valid-mobile", "Invalid Contact Number", (value) => {
      return value ? true : false;
    }),
  // email: yup.string().email('Invalid email format').required('Email Name is required'),

  // recruitOnBehalfOfClients: yup.string().trim().required('Dashboard Type is required'),
  fullAddress: yup.string().trim().required("Company Address is required"),
  businessRoles: yup.string().trim().required("Designation is required"),
  sectorType: yup.object().required("Company Sector is required"),
  businessCategory: yup
    .string()
    .trim()
    .required("Business Category is required"),
  recruitmentAgency: yup
    .string()
    .trim()
    .required("Recruitment Agency is required"),
  // usertype: yup.string().trim().required('Dashboard Type is required'),

  email: yup
    .string()
    .email("Invalid email format")
    .matches(
      /^[a-zA-Z0-9._\-+]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/i,
      "Invalid email format"
    )
    .required("Email Address is required"),
  companyEmail: yup
    .string()
    .email("Invalid email format")
    .matches(
      /^[a-zA-Z0-9._\-+]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/i,
      "Invalid email format"
    )
    .required("Company Email Address is required"),

  city: yup.string().required("City is required"),
  state: yup.string().required("State is required"),
  pincode: yup
    .string()
    .required("pincode is required")
    .matches(/^[0-9]{6}$/, "Pincode must be exactly 6 digits"),
  password: yup
    .string()
    .required("Password is required")
    .min(8, "Password must be at least 8 characters long"),
  // .matches(
  //   /^(?=.*[A-Za-z])(?=.*\d)(?=.*[!@#$%^&*(),.?":{}|<>])[A-Za-z\d!@#$%^&*(),.?":{}|<>]{8,}$/,
  //   "Password must contain at least one uppercase letter, one lowercase letter, one number, and one special character"
  // ),
  documentId: yup.string().trim().required("Document ID is required"),
  documentType: yup.string().trim().required("Document Type is required"),
});
export const CreateEmployerValidationSchemaPart2 = yup.object().shape({
  plan: yup.string().trim().required("Plan is required"),
  transactionId: yup.string().when("hasTransactionId", {
    is: true,
    then: (schema) => schema.trim().required("Transaction ID is required"),
    otherwise: (schema) => schema.trim().notRequired(),
  }),
  mobile: yup
    .string()
    .when("hasTransactionId", {
      is: false,
      then: (schema) =>
        schema
          .required("Mobile Number is required")
          .matches(/^[0-9]{10}$/, "Mobile Number must be exactly 10 digits")
          .test("valid-mobile", "Invalid Mobile Number", (value) => {
            return value ? true : false;
          }),
      otherwise: (schema) => schema.notRequired(),
    }),
  paymentMode: yup.string().when("hasTransactionId", {
    is: false,
    then: (schema) => schema.trim().required("Payment Mode is required"),
    otherwise: (schema) => schema.trim().notRequired(),
  }),
  paymentDate: yup.string().when("hasTransactionId", {
    is: false,
    then: (schema) => schema.trim().required("Payment Date is required"),
    otherwise: (schema) => schema.trim().notRequired(),
  }),
  merchantTransactionId: yup.string().when("hasTransactionId", {
    is: false,
    then: (schema) => schema.trim().required("Merchant Transaction ID is required"),
    otherwise: (schema) => schema.trim().notRequired(),
  }),
});
export const UpdateEmployerValidationSchema = yup.object().shape({
  first_name: yup
    .string()
    .trim()
    .matches(
      /^[A-Za-z\s]+$/,
      "First name should only contain alphabets and spaces"
    )
    .required("First Name is required"),
  middle_name: yup
    .string()
    .trim()
    .matches(
      /^[A-Za-z\s]+$/,
      "Middle name should only contain alphabets and spaces"
    )
    .optional(),
  last_name: yup
    .string()
    .trim()
    .matches(
      /^[A-Za-z\s]+$/,
      "Last name should only contain alphabets and spaces"
    )
    .required("Last Name is required"),
  company_name: yup.string().required("Company Name is required"),
  city: yup.string().required("City is required"),
  // brand_name: yup.string().required("Brand name is required"),
  state: yup.string().required("State is required"),
  // password: yup.string().required("Password is required"),
  address: yup.string().required("Address is required"),
  pincode: yup
    .string()
    .required("pincode is required")
    .matches(/^[0-9]{6}$/, "Pincode must be exactly 6 digits"),
  district: yup.string().trim().required("District is required"),
});

export const JobSahayakValidationSchema = yup.object().shape({
  first_name: yup.string().trim().required("First Name is required"),
  last_name: yup.string().required("Last Name is required"),
  mobile_number: yup
    .string()
    .required("Phone Number is required")
    .matches(/^[0-9]{10}$/, "Phone Number must be exactly 10 digits")
    .test("valid-mobile", "Invalid Phone Number", (value) => {
      return value ? true : false;
    }),
  email_address: yup
    .string()
    .email("Invalid email format")
    .matches(
      /^[a-zA-Z0-9._\-+]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/i,
      "Invalid email format"
    )
    .optional(),
  emgergency_contact_person_name: yup
    .string()
    .required("Emergency Contact Person Name is required"),
  emgergency_contact_mobile: yup
    .string()
    .required("Mobile Number is required")
    .matches(/^[0-9]{10}$/, "Mobile Number must be exactly 10 digits")
    .test("valid-mobile", "Invalid Mobile Number", (value) => {
      return value ? true : false;
    }),
});

export const ValidationSchemaForJobConfiguration = yup.object().shape({
  jobTitleInEnglish: yup
    .string()
    .trim()
    .required("Please enter a valid Job Title"),
  jobTitleInHindi: yup
    .string()
    .trim()
    .required("Please enter a valid Job Title"),
  jobTitleInHinglish: yup
    .string()
    .trim()
    .required("Please enter a valid Job Title"),
  svgPngImg: yup
    .mixed()
    .required("Please upload an Image")
    .test("is-valid-type", "Not a valid image type", (value) => {
      if (!value) return true;
      return validateImageFile(value);
    }),
});

export const validationSchemaForJobSector = yup.object().shape({
  jobSector: yup.string().trim().required("Please enter a Job Sector"),
});

export const validationSchemaForDepartment = yup.object().shape({
  department: yup.string().trim().required("Please enter a Job Sector"),
});

export const QrValidataionSchema = yup.object().shape({
  template_name: yup.string().trim().required("Please select a template"),
  template_size: yup.string().trim().required("Please select a template size"),
  no_of_qr_code: yup
    .number()
    .typeError("Number of Qr code should be a number")
    .required("Please enter no. of qr code")
    .min(5, "No. of QR code must be at least 5")
    .test({
      name: "multipleOfFive",
      message: "No. of QR code must be a multiple of 5",
      test: function (value) {
        return value % 5 === 0;
      },
    })
    .test({
      name: "greaterOrEqual",
      message: "No. of QR code must be greater than or equal to batch size",
      test: function (value) {
        const batchSize = this.resolve(yup.ref("batch_size"));
        if (batchSize !== undefined) {
          return value >= batchSize;
        }
        return true;
      },
    }),
  batch_size: yup
    .number("")
    .typeError("Batch size must be a number")
    .required("Please enter a batch size")
    .positive("Batch size must be greater than 0")
    .test({
      name: "multipleOfFive",
      message: "Batch Size must be a multiple of 5",
      test: function (value) {
        return value % 5 === 0;
      },
    }),
});

export const assignUserSchema = yup.object().shape({
  username: yup.string().trim().required("User name is required"),
});

export const subadminValidationSchema = yup.object().shape({
  first_name: yup.string().trim().required("First Name is required"),
  last_name: yup.string().trim().required("Last Name is required"),
  access_role: yup.string().trim().required("Access Role is required"),
  email_id: yup
    .string()
    .trim()
    .required("Email Address is required")
    .test("Invalid email address provided.", function (value) {
      if (!value) return false;
      const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
      if (emailRegex.test(value)) return true;
      return false;
    }),
  password: yup
    .string()
    .trim()
    .min(6, "Password must be at least 6 characters")
    .required("Password is required"),
});

export const editSubadminValidationSchema = yup.object().shape({
  first_name: yup.string().trim().required("First Name is required"),

  last_name: yup.string().trim().required("Last Name is required"),
  access_role: yup.string().trim().required("Access Role is required"),
  email_id: yup
    .string()
    .trim()
    .required("Email Address is required")
    .test("Invalid email address provided.", function (value) {
      if (!value) return false;
      const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
      if (emailRegex.test(value)) return true;
      return false;
    }),
});

export const CreateAnnouncementValidationSchema = yup.object().shape({
  title: yup.string().required("Title is required"),
  message: yup.string().required("Message is required"),
  bgColor: yup.string().required("Background color is required"),
});

export const UpdateAnnouncementValidationSchema = yup.object().shape({
  title: yup.string().required("Title is required"),
  message: yup.string().required("Message is required"),
  bgColor: yup.string().required("Background color is required"),
});

export const CofigRolesValidationSchema = yup.object().shape({
  role_name: yup.string().required("Role Name is required"),
});

export const validationForCreateTask = yup.object().shape({
  title: yup.string().trim().required("Title is required"),
  // source_location: yup.string().trim().required("Source Location is required"),
  destination_location: yup
    .string()
    .trim()
    .required("Destination Location is required"),
  date_of_arrival: yup
    .date()
    .required("Date Of Arrival is required")
    .min(new Date(), "Date of arrival should not be a past date"),
});

export const validationForAssignTask = yup.object().shape({
  // state: yup.string().trim().required("State is required"),
  // city: yup.string().trim().required("City is required"),
  // jobshayak_name: yup.required("Job Shayak is required"),
});

// export const CreateWhatsAppCampaignValidationSchema = yup.object().shape({
//   campaignName: yup.string().trim().required("Campaign Name is required"),
//   templateId: yup.string().trim().required("Template ID is required"),
//   campaignType: yup.string().trim().required("Campaign Type is required"),
//   csvFile: yup.string().trim().required("csv File is required"),
//   templateLanguage: yup
//     .string()
//     .trim()
//     .required("Template Language is required"),
//   // sendLater: yup.boolean(),
//   // date: yup
//   //   .date()
//   //   .nullable()
//   //   .when("sendLater", {
//   //     is: true,
//   //     then: yup.date().required("Date is required"),
//   //   }),
//   // time: yup
//   //   .string()
//   //   .trim()
//   //   .when("sendLater", {
//   //     is: true,
//   //     then: yup.string().required("Time is required"),
//   //   }),
// });

export const CreateNotificationValidationSchema1 = yup.object().shape({
  Type: yup.string().trim().required("Type is required"),
  radius: yup.string().trim().required("Radius is required"),
  JobId: yup
    .string()
    .trim()
    .when("Type", {
      is: (value) => value !== "Pincode",
      then: (schema) => schema.required("Job Id is required"),
      otherwise: (schema) => schema.notRequired(),
    }),
  pincode: yup
    .string()
    .trim()
    .when("Type", {
      is: "Pincode",
      then: (schema) =>
        schema
          .required("Pincode is required")
          .matches(/^\d{6}$/, "Pincode must be exactly 6 digits"),
      otherwise: (schema) => schema.notRequired(),
    }),
});

export const CreateNotificationValidationSchema2 = yup.object().shape({
  body: yup.string().trim().required("Message is required"),
  title: yup.string().trim().required("Title is required"),
  schedule: yup.boolean().notRequired(),
  scheduledTime: yup
    .string()
    .test(
      "conditional-require-and-future-time",
      "Schedule Time is required and must be in the future when scheduling is enabled",
      function (value) {
        if (!this.parent.schedule) {
          return true; // No validation needed if scheduling is not enabled
        }

        if (!value) {
          return false; // Fail validation if no time is provided when scheduling is enabled
        }

        const scheduledDate = new Date(value);
        const currentDate = new Date();

        return scheduledDate > currentDate; // Ensure the scheduled time is in the future
      }
    ),
});

export const CreateSmsCampaignValidationSchema = yup.object().shape({
  campaignName: yup.string().trim().required("Campaign Name is required"),
  templateId: yup.string().trim().required("Template ID is required"),
  senderHeader: yup.string().trim().required("Sender Header is required"),
  campaignType: yup.string().trim().required("Campaign Type is required"),
  csvFile: yup.string().trim().required("csv File is required"),
  bodyTextContent: yup.string().trim().required("Body is required"),
});
export const CreateEmailCampaignValidationSchema = yup.object().shape({
  campaignName: yup.string().trim().required("Campaign Name is required"),
  bodyTextContent: yup.string().trim().required("Template is required"),
  campaignType: yup.string().trim().required("Campaign Type is required"),
  csvFile: yup.string().trim().required("csv File is required"),
  email_from: yup.string().trim().required("Email from is required"),
});

export const CreateJSKValidationSchema = yup.object().shape({
  first_name: yup
    .string()
    .trim()
    .matches(
      /^[A-Za-z\s]+$/,
      "First name should only contain alphabets and spaces"
    )
    .required("First name is required"),
  middle_name: yup
    .string()
    .trim()
    .matches(
      /^[A-Za-z\s]+$/,
      "Middle name should only contain alphabets and spaces"
    )
    .optional(),
  last_name: yup
    .string()
    .trim()
    .matches(
      /^[A-Za-z\s]+$/,
      "Last name should only contain alphabets and spaces"
    )
    .required("Last name is required"),
  date_of_birth: yup
    .date()
    .max(
      new Date(new Date().setFullYear(new Date().getFullYear() - 18)),
      "Date of Birth is not valid"
    )
    .required("Date of birth is required"),
  email: yup
    .string()
    .email("Invalid email format")
    .matches(
      /^[a-zA-Z0-9._\-+]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/i,
      "Invalid email format"
    ),
  registered_mobile_number: yup
    .string()
    .required("Mobile number is required")
    .matches(/^[0-9]{10}$/, "Mobile number must be exactly 10 digits"),
  communication_perference: yup
    .array()
    .of(tradeSchema)
    .required("Communication perference is required")
    .min(1, "At least one communication perference is required"),
  shop_name: yup
    .string()
    .trim()
    .matches(
      /^[A-Za-z\s]+$/,
      "Shop name should only contain alphabets and spaces"
    )
    .required("Shop name is required"),
  shop_address: yup.string().trim().required("Shop address is required"),
  shop_location: yup.string().trim().required("Shop location is required"),
  gst_details: yup.string().trim().required("GST details are required"),
  house_number: yup.string().trim().required("House number is required"),
  pincode: yup
    .string()
    .trim()
    .matches(/^[1-9][0-9]{5}$/, "Invalid pincode")
    .required("Pincode is required"),
  state: yup.string().trim().required("State is required"),
  bank_details_option: yup
    .string()
    .trim()
    .required("Bank details are required"),
  account_number: yup.string().when("bank_details_option", {
    is: "bank_details",
    then: () => yup.string().trim().required("Account number is required"),
  }),
  confirm_account_number: yup.string().when("bank_details_option", {
    is: "bank_details",
    then: () =>
      yup.string().trim().required("Confirm account number is required"),
  }),
  ifsc_code: yup.string().when("bank_details_option", {
    is: "bank_details",
    then: () => yup.string().trim().required("IFSC is required"),
  }),
  account_holder_name: yup.string().when("bank_details_option", {
    is: "bank_details",
    then: () =>
      yup
        .string()
        .trim()
        .matches(
          /^[A-Za-z\s]+$/,
          "Account holder name should only contain alphabets and spaces"
        )
        .required("Account holder name is required"),
  }),
  upi_id: yup.string().when("bank_details_option", {
    is: "upi_details",
    then: () => yup.string().trim().required("UPI ID is required"),
  }),
});

export const AddEmployerCreditsValidationSchema = yup.object().shape({
  creditMode: yup.string().required("Credit mode is required"),
  creditType: yup.number().required("Credit type is required"),
  operation: yup.string().required("Operation is required"),
  reason: yup.string().trim().required("Reason is required"),
  systemMessage: yup.string().trim().required("System message is required"),

  // Custom credit fields
  creditAmount: yup.number().when("creditMode", {
    is: "custom",
    then: (schema) => schema
      .required("Credit amount is required")
      .positive("Credit amount must be positive")
      .typeError("Credit amount must be a number"),
    otherwise: (schema) => schema.notRequired(),
  }),

  validityDays: yup.number().when(["creditMode", "operation"], {
    is: (creditMode, operation) => creditMode === "custom" && operation === "credit",
    then: (schema) => schema
      .required("Validity days is required")
      .positive("Validity days must be positive")
      .integer("Validity days must be a whole number")
      .typeError("Validity days must be a number"),
    otherwise: (schema) => schema.notRequired(),
  }),

  // Addon pack field
  addonId: yup.string().when("creditMode", {
    is: "addon",
    then: (schema) => schema.required("Please select an addon pack"),
    otherwise: (schema) => schema.notRequired(),
  }),

  // Payment transaction fields
  hasPaymentTransaction: yup.boolean(),

  amount: yup.number().when("hasPaymentTransaction", {
    is: true,
    then: (schema) => schema
      .required("Payment amount is required")
      .positive("Payment amount must be positive")
      .typeError("Payment amount must be a number"),
    otherwise: (schema) => schema.notRequired(),
  }),

  paymentMode: yup.string().when("hasPaymentTransaction", {
    is: true,
    then: (schema) => schema.required("Payment mode is required"),
    otherwise: (schema) => schema.notRequired(),
  }),

  bankTransactionId: yup.string().trim(),
  paymentGatewayTransactionId: yup.string().trim(),
  paymentGatewayServiceTransactionId: yup.string().trim(),
  bankId: yup.string().trim(),
  arn: yup.string().trim(),
});

export const CreateJWPValidationSchema = yup.object().shape({
  first_name: yup
    .string()
    .trim()
    .matches(
      /^[A-Za-z\s]+$/,
      "First name should only contain alphabets and spaces"
    )
    .required("First name is required"),
  middle_name: yup
    .string()
    .trim()
    .matches(
      /^[A-Za-z\s]+$/,
      "Middle name should only contain alphabets and spaces"
    )
    .optional(),
  last_name: yup
    .string()
    .trim()
    .matches(
      /^[A-Za-z\s]+$/,
      "Last name should only contain alphabets and spaces"
    )
    .required("Last name is required"),
  date_of_birth: yup
    .date()
    .max(
      new Date(new Date().setFullYear(new Date().getFullYear() - 18)),
      "Date of Birth is not valid"
    )
    .required("Date of birth is required"),
  email: yup
    .string()
    .email("Invalid email format")
    .matches(
      /^[a-zA-Z0-9._\-+]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/i,
      "Invalid email format"
    )
    .required("Email Address is required"),
  registered_mobile_number: yup
    .string()
    .required("Mobile number is required")
    .matches(/^[0-9]{10}$/, "Mobile number must be exactly 10 digits"),
  communication_perference: yup
    .array()
    .of(tradeSchema)
    .required("Communication perference is required")
    .min(1, "At least one communication perference is required"),
  business_category: yup
    .string()
    .trim()
    .required("Business category is required"),
  business_address: yup
    .string()
    .trim()
    .required("Business address is required"),
  business_postal_code: yup
    .string()
    .trim()
    .matches(/^[1-9][0-9]{5}$/, "Invalid pincode")
    .required("Business postal code is required"),
  business_phone_number: yup
    .string()
    .required("Phone Number is required")
    .matches(/^[0-9]{10}$/, "Phone Number must be exactly 10 digits")
    .test("valid-mobile", "Invalid Phone Number", (value) => {
      return value ? true : false;
    }),
  house_number: yup.string().trim().required("House number is required"),
  pincode: yup
    .string()
    .trim()
    .matches(/^[1-9][0-9]{5}$/, "Invalid pincode")
    .required("Pincode is required"),
  bank_details_option: yup
    .string()
    .trim()
    .required("Bank details are required"),
  account_number: yup.string().when("bank_details_option", {
    is: "bank_details",
    then: () => yup.string().trim().required("Account number is required"),
  }),
  confirm_account_number: yup.string().when("bank_details_option", {
    is: "bank_details",
    then: () =>
      yup.string().trim().required("Confirm account number is required"),
  }),
  ifsc_code: yup.string().when("bank_details_option", {
    is: "bank_details",
    then: () => yup.string().trim().required("IFSC is required"),
  }),
  account_holder_name: yup.string().when("bank_details_option", {
    is: "bank_details",
    then: () =>
      yup
        .string()
        .trim()
        .matches(
          /^[A-Za-z\s]+$/,
          "Account holder name should only contain alphabets and spaces"
        )
        .required("Account holder name is required"),
  }),
  upi_id: yup.string().when("bank_details_option", {
    is: "upi_details",
    then: () => yup.string().trim().required("UPI ID is required"),
  }),
});

export const CreateSectorValidationSchema = yup.object().shape({
  sectorNameEn: yup
    .string()
    .required("Sector Name English is required")
    .trim()
    .matches(
      /^[A-Za-z0-9\s!@#$%^&*()_+=\-[\]{};:"\\|,.<>?]*$/,
      "Sector Name English should only contain alphabets, numbers, and special characters"
    ),
  sectorNameHi: yup
    .string()
    .required("Sector Name Hindi is required")
    .trim()
    .matches(
      /^[\u0900-\u097F0-9\s!@#$%^&*()_+\-=\[\]{};:"\\|,.<>\/?]*$/,
      "Sector Name Hindi should only contain Hindi alphabets, numbers, and special characters"
    ),
  sectorNameHn: yup
    .string()
    .required("Sector Name Hinglish is required")
    .trim()
    .matches(
      /^[\u0900-\u097FA-Za-z0-9\s!@#$%^&*()_+\-=\[\]{};:"\\|,.<>\/?]*$/,
      "Sector Name Hinglish should only contain alphabets, numbers, and special characters"
    ),
  sectorNameTa: yup
    .string()
    .required("Sector Name Tamil is required")
    .trim()
    .matches(
      /^[\u0B80-\u0BFF0-9\s!@#$%^&*()_+\-=\[\]{};:"\\|,.<>\/?]*$/,
      "Sector Name Tamil should only contain Tamil characters, numbers, and special characters"
    ),
  // Telugu validation: Unicode range U+0C00 to U+0C7F
  sectorNameTe: yup
    .string()
    .required("Sector Name Telugu is required")
    .trim()
    .matches(
      /^[\u0C00-\u0C7F0-9\s!@#$%^&*()_+\-=\[\]{};:"\\|,.<>\/?]*$/,
      "Sector Name Telugu should only contain Telugu characters, numbers, and special characters"
    ),
  // Kannada validation: Unicode range U+0C80 to U+0CFF
  sectorNameKn: yup
    .string()
    .required("Sector Name Kannada is required")
    .trim()
    .matches(
      /^[\u0C80-\u0CFF0-9\s!@#$%^&*()_+\-=\[\]{};:"\\|,.<>\/?]*$/,
      "Sector Name Kannada should only contain Kannada characters, numbers, and special characters"
    ),
  // Bengali validation: Unicode range U+0980 to U+09FF
  sectorNameBn: yup
    .string()
    .required("Sector Name Bengali is required")
    .trim()
    .matches(
      /^[\u0980-\u09FF0-9\s!@#$%^&*()_+\-=\[\]{};:"\\|,.<>\/?]*$/,
      "Sector Name Bengali should only contain Bengali characters, numbers, and special characters"
    ),
  // Gujarati validation: Unicode range U+0A80 to U+0AFF
  sectorNameGu: yup
    .string()
    .required("Sector Name Gujarati is required")
    .trim()
    .matches(
      /^[\u0A80-\u0AFF0-9\s!@#$%^&*()_+\-=\[\]{};:"\\|,.<>\/?]*$/,
      "Sector Name Gujarati should only contain Gujarati characters, numbers, and special characters"
    ),
  // Marathi uses Devanagari, similar to Hindi (Unicode range U+0900 to U+097F)
  sectorNameMr: yup
    .string()
    .required("Sector Name Marathi is required")
    .trim()
    .matches(
      /^[\u0900-\u097F0-9\s!@#$%^&*()_+\-=\[\]{};:"\\|,.<>\/?]*$/,
      "Sector Name Marathi should only contain Marathi (Devanagari) characters, numbers, and special characters"
    ),
});

export const CreateOccupationValidationSchema = yup.object().shape({
  occupationNameEn: yup
    .string()
    .required("Occupation Name English is required")
    .trim()
    .matches(
      /^[A-Za-z0-9\s!@#$%^&*()_+\-=\[\]{};:"\\|,.<>\/?]*$/,
      "Occupation Name English should only contain alphabets"
    ),
  occupationNameHi: yup
    .string()
    .required("Occupation Name Hindi is required")
    .trim()
    .matches(
      /^[\u0900-\u097F0-9\s!@#$%^&*()_+\-=\[\]{};:"\\|,.<>\/?]*$/,
      "Occupation Name Hindi should only contain Hindi alphabets"
    ),
  occupationNameHn: yup
    .string()
    .required("Occupation Name Hinglish is required")
    .trim()
    .matches(
      /^[\u0900-\u097FA-Za-z0-9\s!@#$%^&*()_+\-=\[\]{};:"\\|,.<>\/?]*$/,
      "Occupation Name Hinglish should only contain alphabets"
    ),
  occupationNameTa: yup
    .string()
    .required("Occupation Name Tamil is required")
    .trim()
    .matches(
      /^[\u0B80-\u0BFF0-9\s!@#$%^&*()_+\-=\[\]{};:"\\|,.<>\/?]*$/,
      "Occupation Name Tamil should only contain Tamil characters, numbers, and special characters"
    ),
  // Telugu validation: Unicode range U+0C00 to U+0C7F
  occupationNameTe: yup
    .string()
    .required("Occupation Name Telugu is required")
    .trim()
    .matches(
      /^[\u0C00-\u0C7F0-9\s!@#$%^&*()_+\-=\[\]{};:"\\|,.<>\/?]*$/,
      "Occupation Name Telugu should only contain Telugu characters, numbers, and special characters"
    ),
  // Kannada validation: Unicode range U+0C80 to U+0CFF
  occupationNameKn: yup
    .string()
    .required("Occupation Name Kannada is required")
    .trim()
    .matches(
      /^[\u0C80-\u0CFF0-9\s!@#$%^&*()_+\-=\[\]{};:"\\|,.<>\/?]*$/,
      "Occupation Name Kannada should only contain Kannada characters, numbers, and special characters"
    ),
  // Bengali validation: Unicode range U+0980 to U+09FF
  occupationNameBn: yup
    .string()
    .required("Occupation Name Bengali is required")
    .trim()
    .matches(
      /^[\u0980-\u09FF0-9\s!@#$%^&*()_+\-=\[\]{};:"\\|,.<>\/?]*$/,
      "Occupation Name Bengali should only contain Bengali characters, numbers, and special characters"
    ),
  // Gujarati validation: Unicode range U+0A80 to U+0AFF
  occupationNameGu: yup
    .string()
    .required("Occupation Name Gujarati is required")
    .trim()
    .matches(
      /^[\u0A80-\u0AFF0-9\s!@#$%^&*()_+\-=\[\]{};:"\\|,.<>\/?]*$/,
      "Occupation Name Gujarati should only contain Gujarati characters, numbers, and special characters"
    ),
  // Marathi uses Devanagari, similar to Hindi (Unicode range U+0900 to U+097F)
  occupationNameMr: yup
    .string()
    .required("Occupation Name Marathi is required")
    .trim()
    .matches(
      /^[\u0900-\u097F0-9\s!@#$%^&*()_+\-=\[\]{};:"\\|,.<>\/?]*$/,
      "Occupation Name Marathi should only contain Marathi (Devanagari) characters, numbers, and special characters"
    )
});

export const CreateOccupationValidationSecondSchema = yup.object().shape({
  ncoId: yup.string().required("This field is required"),

})

export const CreateJobRolesValidationSchema = yup.object().shape({
  jobRoleNameEn: yup
    .string()
    .required("Job Role Name English is required")
    .trim()
    .matches(
      /^[A-Za-z0-9\s!@#$%^&*()_+\-=\[\]{};:"\\|,.<>\/?]*$/,
      "Job Role Name English should only contain alphabets"
    ),
  jobRoleNameHi: yup
    .string()
    .required("Job Role Name Hindi is required")
    .trim()
    .matches(
      /^[\u0900-\u097F0-9\s!@#$%^&*()_+\-=\[\]{};:"\\|,.<>\/?]*$/,
      "Job Role Name Hindi should only contain Hindi alphabets"
    ),
  jobRoleNameHn: yup
    .string()
    .required("Job Role Name Hinglish is required")
    .trim()
    .matches(
      /^[\u0900-\u097FA-Za-z0-9\s!@#$%^&*()_+\-=\[\]{};:"\\|,.<>\/?]*$/,
      "Job Role Name Hinglish should only contain alphabets"
    ),
  jobRoleNameTa: yup
    .string()
    .required("Job Role Name Tamil is required")
    .trim()
    .matches(
      /^[\u0B80-\u0BFF0-9\s!@#$%^&*()_+\-=\[\]{};:"\\|,.<>\/?]*$/,
      "Job Role Name Tamil should only contain Tamil characters, numbers, and special characters"
    ),
  // Telugu validation: Unicode range U+0C00 to U+0C7F
  jobRoleNameTe: yup
    .string()
    .required("Job Role Name Telugu is required")
    .trim()
    .matches(
      /^[\u0C00-\u0C7F0-9\s!@#$%^&*()_+\-=\[\]{};:"\\|,.<>\/?]*$/,
      "Job Role Name Telugu should only contain Telugu characters, numbers, and special characters"
    ),
  // Kannada validation: Unicode range U+0C80 to U+0CFF
  jobRoleNameKn: yup
    .string()
    .required("Job Role Name Kannada is required")
    .trim()
    .matches(
      /^[\u0C80-\u0CFF0-9\s!@#$%^&*()_+\-=\[\]{};:"\\|,.<>\/?]*$/,
      "Job Role Name Kannada should only contain Kannada characters, numbers, and special characters"
    ),
  // Bengali validation: Unicode range U+0980 to U+09FF
  jobRoleNameBn: yup
    .string()
    .required("Job Role Name Bengali is required")
    .trim()
    .matches(
      /^[\u0980-\u09FF0-9\s!@#$%^&*()_+\-=\[\]{};:"\\|,.<>\/?]*$/,
      "Job Role Name Bengali should only contain Bengali characters, numbers, and special characters"
    ),
  // Gujarati validation: Unicode range U+0A80 to U+0AFF
  jobRoleNameGu: yup
    .string()
    .required("Job Role Name Gujarati is required")
    .trim()
    .matches(
      /^[\u0A80-\u0AFF0-9\s!@#$%^&*()_+\-=\[\]{};:"\\|,.<>\/?]*$/,
      "Job Role Name Gujarati should only contain Gujarati characters, numbers, and special characters"
    ),
  // Marathi uses Devanagari, similar to Hindi (Unicode range U+0900 to U+097F)
  jobRoleNameMr: yup
    .string()
    .required("Job Role Name Marathi is required")
    .trim()
    .matches(
      /^[\u0900-\u097F0-9\s!@#$%^&*()_+\-=\[\]{};:"\\|,.<>\/?]*$/,
      "Job Role Name Marathi should only contain Marathi (Devanagari) characters, numbers, and special characters"
    ),

});

export const CreateJobRolesValidationSecondSchema = yup.object().shape({
  ncoCode: yup
    .string()
    .trim()
    .required("NCO Code is required")
    .matches(
      /^[0-9]+(\.[0-9]+)?$/,
      "NCO Code should be a numeric or decimal value"
    ),

  nsqfLevel: yup
    .string()
    .trim()
    .required("NSQF Level is required")
    .matches(/^[0-9]+$/, "NSQF Level should be a numeric value"),
})

export const CreateJobRolesValidationThirdSchema = yup.object().shape({
  hiringCreditPerVacancy: yup
    .string()
    .trim()
    .required("Hiring Credit per vacancy is required")
    .matches(/^[0-9]+$/, "It should be a numeric value"),
  mulHiringCreditAfterVacancy: yup
    .string()
    .trim()
    .required("Mutiple Hiring Credit after First Vacancy is required")
    .matches(/^[0-9]+$/, "It should be a numeric value"),
  hiringCreditForContact: yup
    .string()
    .trim()
    .required("Hiring Credit for contact is required")
    .matches(/^[0-9]+$/, "It should be a numeric value"),
  hiringCreditForCVDownload: yup
    .string()
    .trim()
    .required("Hiring Credit for cv download is required")
    .matches(/^[0-9]+$/, "It should be a numeric value"),
})

export const CreateRecruiterClientValidationSchema = yup.object().shape({
  employerName: yup
    .string()
    .trim()
    .matches(
      /^[A-Za-z\s]+$/,
      "Employer name should only contain alphabets and spaces"
    )
    .required("Company Name is required"),
  organizationName: yup
    .string()
    .trim()
    .required("Organization Name is required"),
  tradeOrBrandName: yup
    .string()
    .trim()
    .required("Trade/Brand Name is required"),
  organizationSector: yup
    .mixed()
    .test(
      "is-string-or-object",
      "Organization Sector must be a string or an object",
      (value) => {
        return (
          typeof value === "string" ||
          (typeof value === "object" && value !== null)
        );
      }
    )
    .required("Organization Sector is required"),
});

export const CreateRecruiterValidationSchema = yup.object().shape({
  companyName: yup.string().trim().required("Company Name is required"),
  firstName: yup.string().trim().required("First Name is required"),
  lastName: yup.string().trim().required("Last Name is required"),
  phone: yup
    .string()
    .required("Contact Number is required")
    .matches(/^[0-9]{10}$/, "Contact Number must be exactly 10 digits")
    .test("valid-mobile", "Invalid Contact Number", (value) => {
      return value ? true : false;
    }),
  // email: yup.string().email('Invalid email format').required('Email Name is required'),

  // recruitOnBehalfOfClients: yup.string().trim().required('Dashboard Type is required'),
  fullAddress: yup.string().trim().required("Company Address is required"),
  businessRoles: yup.string().trim().required("Designation is required"),
  // sectorType: yup.object().required("Company Sector is required"),
  businessCategory: yup
    .string()
    .trim()
    .required("Business Category is required"),
  recruitmentAgency: yup
    .string()
    .trim()
    .required("Recruitment Agency is required"),
  // usertype: yup.string().trim().required('Dashboard Type is required'),

  email: yup
    .string()
    .email("Invalid email format")
    .matches(
      /^[a-zA-Z0-9._\-+]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/i,
      "Invalid email format"
    )
    .required("Email Address is required"),

  companyEmail: yup
    .string()
    .email("Invalid email format")
    .matches(
      /^[a-zA-Z0-9._\-+]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/i,
      "Invalid email format"
    )
    .required("Company Email is required"),

  city: yup.string().required("City is required"),
  state: yup.string().required("State is required"),
  pincode: yup
    .string()
    .required("pincode is required")
    .matches(/^[0-9]{6}$/, "Pincode must be exactly 6 digits"),
  password: yup
    .string()
    .required("Password is required")
    .min(8, "Password must be at least 8 characters long"),
  // .matches(
  //   /^(?=.*[A-Za-z])(?=.*\d)(?=.*[!@#$%^&*(),.?":{}|<>])[A-Za-z\d!@#$%^&*(),.?":{}|<>]{8,}$/,
  //   "Password must contain at least one uppercase letter, one lowercase letter, one number, and one special character"
  // ),
  documentId: yup.string().trim().required("Document ID is required"),
  documentType: yup.string().trim().required("Document Type is required"),
});

export const UpdateJobValidationSchema = yup.object().shape({
  // jobSector: yup.string().trim().required('Job Sector is required'),
  jobOccupation: yup.string().trim().required("Job Occupation is required"),
  jobRole: yup.string().trim().required("Job Role is required"),
});

export const UpdateJobRejectValidationSchema = yup.object().shape({
  comments: yup.string().trim().required("Comments are required"),
});

export const CreateFirstFormValidationSchema = yup.object().shape({
  campaignName: yup.string().trim().required("Campaign name is required"),
  campaignTag: yup.object().required("Campaign Tag is required"),
  campaignType: yup.string().trim().required("Campaign Type is required"),
  sendLater: yup.boolean(),
  scheduleTime: yup
    .date()
    .nullable()
    .when("sendLater", {
      is: true,
      then: (schema) =>
        schema
          .required("Date is required when sending later")
          .min(new Date(), "Date cannot be in the past"),
      otherwise: (schema) => schema.nullable(),
    }),
});

export const CreateSecondFormValidationSchema = yup.object().shape({
  dataSource: yup.string().trim().required("Data source is required"),
  condition: yup.string().when("dataSource", {
    is: (value) => value !== "CSV",
    then: () => yup.string().trim().required("Condition is required"),
  }),
});

export const CreateThirdFormValidationSchema = yup.object().shape({
  templateId: yup.string().trim().required("Template id is required"),
  jobId2: yup.string().when(["isJobId", "dataSource"], {
    is: (isJobId, dataSource) => {
      // console.log("isJobId:", isJobId);
      // console.log("dataSource:", dataSource);
      return isJobId && dataSource !== "CSV";
    },
    then: (schema) => schema.required("Job Id is required"),
    otherwise: (schema) => schema.notRequired(),
  }),
});



export const EmailCampaignFirstFormValidationSchema = yup.object().shape({
  campaignName: yup.string().trim().required("Campaign Name is required"),
  tag: yup.object().required("Campaign Tag is required"),
  campaignType: yup.string().trim().required("Campaign Type is required"),
  sendLater: yup.boolean(),
  scheduledTime: yup
    .date()
    .nullable()
    .when("sendLater", {
      is: true,
      then: (schema) =>
        schema
          .required("Date is required when sending later")
          .min(new Date(), "Date cannot be in the past"),
      otherwise: (schema) => schema.nullable(),
    }),
});

export const EmailCampaignSecondFormValidationSchema = yup.object().shape({
  dataSource: yup.string().trim().required("Data Source is required"),
  condition: yup.string().trim().required("Condition is required"),
  // startDate: yup.string().trim().required("Date Range is required"),
});

const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const EmailCampaignThirdFormValidationSchema = yup.object().shape({
  from: yup
    .string()
    .trim()
    .required("Email Address is required")
    .matches(emailRegex, "Please enter a valid email Address"),
  templateId: yup.string().trim().required("Template is required"),
  cc: yup
    .string()
    .trim()
    .nullable()
    .matches(emailRegex, "Please enter a valid email Address for CC"),
  bcc: yup
    .string()
    .trim()
    .nullable()
    .matches(emailRegex, "Please enter a valid email Address for BCC"),
});

export const NotificationCampaignFirstFormSchema = yup.object().shape({
  notificationName: yup
    .string()
    .trim()
    .required("Notification Name is required"),
  tag: yup.object().required("Tag is required"),
  notificationType: yup
    .string()
    .trim()
    .required("Notification Type is required"),
  sendLater: yup.boolean(),
  scheduledTime: yup
    .date()
    .nullable()
    .when("sendLater", {
      is: true,
      then: (schema) =>
        schema
          .required("Date is required when sending later")
          .min(new Date(), "Date cannot be in the past"),
      otherwise: (schema) => schema.nullable(),
    }),
  modeOfSend: yup.string().trim().required("Notfication Type is required"),
});

export const NotificationCampaignSecondFormSchema = yup.object().shape({
  condition: yup.string().required("Condition is required"),
  jobId: yup
    .string()
    .nullable()
    .when("condition", {
      is: "Job Id",
      then: (schema) => schema.required("Job Id is required"),
      otherwise: (schema) => schema.nullable(),
    }),
  pincode: yup
    .string()
    .nullable()
    .when("condition", {
      is: "Pincode",
      then: (schema) =>
        schema
          .required("Pincode is required")
          .matches(/^\d{6}$/, "Pincode must be a 6-digit number"),
      otherwise: (schema) => schema.nullable(),
    }),
  radius: yup
    .number()
    .nullable()
    .when("condition", {
      is: "Pincode",
      then: (schema) =>
        schema
          .required("Radius is required")
          .moreThan(0, "Radius must be greater than zero"),
      otherwise: (schema) => schema.nullable(),
    }),
});

export const NotificationBannerCampaignSecondFormSchema = yup.object().shape({
  condition: yup.string().required("Condition is required"),
  jobId: yup
    .string()
    .nullable()
    .when("condition", {
      is: "Job Id",
      then: (schema) => schema.required("Job Id is required"),
      otherwise: (schema) => schema.nullable(),
    }),
  pincode: yup
    .string()
    .nullable()
    .when("condition", {
      is: "Pincode",
      then: (schema) =>
        schema
          .required("Pincode is required")
          .matches(/^\d{6}$/, "Pincode must be a 6-digit number"),
      otherwise: (schema) => schema.nullable(),
    }),
  radius: yup
    .number()
    .required("Radius is required")
    .moreThan(0, "Radius must be greater than zero"),
});

export const thirdFormNotificationValidationSchema = yup.object().shape({
  title: yup.string().trim().required("Notification Title is required"),
  description: yup.string().required("Notification Body is required"),
  notificationTypeIs: yup.string().trim().required("Notification Type is required"),
  jobIdIs: yup
    .string()
    .nullable()
    .when("notificationTypeIs", {
      is: "new_job_posted_1",
      then: (schema) => schema.required("Job Id is required"),
      otherwise: (schema) => schema.nullable(),
    }),
  urlIs: yup
    .string()
    .nullable()
    .when("notificationTypeIs", {
      is: "link",
      then: (schema) =>
        schema
          .required("URL is required")
          .matches(/^https:\/\//, "URL must start with https://"),
      otherwise: (schema) => schema.nullable(),
    }),

});

export const thirdFormBannerValidationSchema = yup.object().shape({

  tagTextEn: yup
    .string()
    .trim()
    .when("bannerType", {
      is: (val) => val !== "boolean",
      then: (schema) =>
        schema
          .required("Tag text in english is required")
          .matches(
            /^[A-Za-z0-9\s!@#$%^&*()_+\-=\[\]{};:"\\|,.<>\/?]*$/,
            "Tag text in english should only contain alphabets"
          ),
      otherwise: (schema) =>
        schema
          .notRequired()
          .nullable()
          .test("valid-if-present", "Tag text in english should only contain alphabets", function (value) {
            if (!value) return true;
            return /^[A-Za-z0-9\s!@#$%^&*()_+\-=\[\]{};:"\\|,.<>\/?]*$/.test(value);
          }),
    }),

  tagTextHi: yup
    .string()
    .trim()
    .when("bannerType", {
      is: (val) => val !== "boolean",
      then: (schema) =>
        schema
          .required("Tag text in hindi is required")
          .matches(
            /^[\u0900-\u097F0-9\s!@#$%^&*()_+\-=\[\]{};:"\\|,.<>\/?]*$/,
            "Tag text in hindi should only contain Hindi alphabets"
          ),
      otherwise: (schema) =>
        schema
          .notRequired()
          .nullable()
          .test(
            "valid-if-present",
            "Tag text in hindi should only contain Hindi alphabets",
            (value) =>
              !value ||
              /^[\u0900-\u097F0-9\s!@#$%^&*()_+\-=\[\]{};:"\\|,.<>\/?]*$/.test(
                value
              )
          ),
    }),

  tagTextHn: yup
    .string()
    .trim()
    .when("bannerType", {
      is: (val) => val !== "boolean",
      then: (schema) =>
        schema
          .required("Tag text in hinglish is required")
          .matches(
            /^[A-Za-z0-9\s!@#$%^&*()_+\-=\[\]{};:"\\|,.<>\/?]*$/,
            "Tag text in hinglish should only contain alphabets"
          ),
      otherwise: (schema) =>
        schema
          .notRequired()
          .nullable()
          .test(
            "valid-if-present",
            "Tag text in hinglish should only contain alphabets",
            (value) =>
              !value ||
              /^[A-Za-z0-9\s!@#$%^&*()_+\-=\[\]{};:"\\|,.<>\/?]*$/.test(value)
          ),
    }),


  tagTextBn: yup
    .string()
    .trim()
    .when("bannerType", {
      is: (val) => val !== "boolean",
      then: (schema) =>
        schema
          .required("Tag text in Bengali is required")
          .matches(
            /^[\u0980-\u09FF0-9\s!@#$%^&*()_+\-=\[\]{};:"\\|,.<>\/?]*$/,
            "Tag text in Bengali should only contain Bengali alphabets"
          ),
      otherwise: (schema) =>
        schema
          .notRequired()
          .nullable()
          .test(
            "valid-if-present",
            "Tag text in Bengali should only contain Bengali alphabets",
            (value) =>
              !value ||
              /^[\u0980-\u09FF0-9\s!@#$%^&*()_+\-=\[\]{};:"\\|,.<>\/?]*$/.test(
                value
              )
          ),
    }),


  tagTextTa: yup
    .string()
    .trim()
    .when("bannerType", {
      is: (val) => val !== "boolean",
      then: (schema) =>
        schema
          .required("Tag text in Tamil is required")
          .matches(
            /^[\u0B80-\u0BFF0-9\s!@#$%^&*()_+\-=\[\]{};:"\\|,.<>\/?]*$/,
            "Tag text in Tamil should only contain Tamil alphabets"
          ),
      otherwise: (schema) =>
        schema
          .notRequired()
          .nullable()
          .test(
            "valid-if-present",
            "Tag text in Tamil should only contain Tamil alphabets",
            (value) =>
              !value ||
              /^[\u0B80-\u0BFF0-9\s!@#$%^&*()_+\-=\[\]{};:"\\|,.<>\/?]*$/.test(
                value
              )
          ),
    }),


  tagTextTe: yup
    .string()
    .trim()
    .when("bannerType", {
      is: (val) => val !== "boolean",
      then: (schema) =>
        schema
          .required("Tag text in Telugu is required")
          .matches(
            /^[\u0C00-\u0C7F0-9\s!@#$%^&*()_+\-=\[\]{};:"\\|,.<>\/?]*$/,
            "Tag text in Telugu should only contain Telugu alphabets"
          ),
      otherwise: (schema) =>
        schema
          .notRequired()
          .nullable()
          .test(
            "valid-if-present",
            "Tag text in Telugu should only contain Telugu alphabets",
            (value) =>
              !value ||
              /^[\u0C00-\u0C7F0-9\s!@#$%^&*()_+\-=\[\]{};:"\\|,.<>\/?]*$/.test(
                value
              )
          ),
    }),


  tagTextKn: yup
    .string()
    .trim()
    .when("bannerType", {
      is: (val) => val !== "boolean",
      then: (schema) =>
        schema
          .required("Tag text in Kannada is required")
          .matches(
            /^[\u0C80-\u0CFF0-9\s!@#$%^&*()_+\-=\[\]{};:"\\|,.<>\/?]*$/,
            "Tag text in Kannada should only contain Kannada alphabets"
          ),
      otherwise: (schema) =>
        schema
          .notRequired()
          .nullable()
          .test(
            "valid-if-present",
            "Tag text in Kannada should only contain Kannada alphabets",
            (value) =>
              !value ||
              /^[\u0C80-\u0CFF0-9\s!@#$%^&*()_+\-=\[\]{};:"\\|,.<>\/?]*$/.test(
                value
              )
          ),
    }),

  tagTextMr: yup
    .string()
    .trim()
    .when("bannerType", {
      is: (val) => val !== "boolean",
      then: (schema) =>
        schema
          .required("Tag text in Marathi is required")
          .matches(
            /^[\u0900-\u097F0-9\s!@#$%^&*()_+\-=\[\]{};:"\\|,.<>\/?]*$/,
            "Tag text in Marathi should only contain Marathi alphabets"
          ),
      otherwise: (schema) =>
        schema
          .notRequired()
          .nullable()
          .test(
            "valid-if-present",
            "Tag text in Marathi should only contain Marathi alphabets",
            (value) =>
              !value ||
              /^[\u0900-\u097F0-9\s!@#$%^&*()_+\-=\[\]{};:"\\|,.<>\/?]*$/.test(
                value
              )
          ),
    }),


  tagTextGu: yup
    .string()
    .trim()
    .when("bannerType", {
      is: (val) => val !== "boolean",
      then: (schema) =>
        schema
          .required("Tag text in Gujarati is required")
          .matches(
            /^[\u0A80-\u0AFF0-9\s!@#$%^&*()_+\-=\[\]{};:"\\|,.<>\/?]*$/,
            "Tag text in Gujarati should only contain Gujarati alphabets"
          ),
      otherwise: (schema) =>
        schema
          .notRequired()
          .nullable()
          .test(
            "valid-if-present",
            "Tag text in Gujarati should only contain Gujarati alphabets",
            (value) =>
              !value ||
              /^[\u0A80-\u0AFF0-9\s!@#$%^&*()_+\-=\[\]{};:"\\|,.<>\/?]*$/.test(
                value
              )
          ),
    }),





  titleEn: yup
    .string()
    .required("Title in english is required")
    .trim()
    .matches(
      /^[A-Za-z0-9\s!@#$%^&*()_+\-=\[\]{};:"\\|,.<>\/?]*$/,
      "Title in english should only contain alphabets"
    ),
  titleHi: yup
    .string()
    .required("Title in hindi is required")
    .trim()
    .matches(
      /^[\u0900-\u097F0-9\s!@#$%^&*()_+\-=\[\]{};:"\\|,.<>\/?]*$/,
      "Title in hindi should only contain Hindi alphabets"
    ),
  titleHn: yup
    .string()
    .required("Title in hinglish is required")
    .trim()
    .matches(
      /^[A-Za-z0-9\s!@#$%^&*()_+\-=\[\]{};:"\\|,.<>\/?]*$/,
      "Title in hinglish should only contain alphabets"
    ),

  titleBn: yup
    .string()
    .required("Title in Bengali is required")
    .trim()
    .matches(
      /^[\u0980-\u09FF0-9\s!@#$%^&*()_+\-=\[\]{};:"\\|,.<>\/?]*$/,
      "Title in Bengali should only contain Bengali alphabets"
    ),

  titleTa: yup
    .string()
    .required("Title in Tamil is required")
    .trim()
    .matches(
      /^[\u0B80-\u0BFF0-9\s!@#$%^&*()_+\-=\[\]{};:"\\|,.<>\/?]*$/,
      "Title in Tamil should only contain Tamil alphabets"
    ),

  titleTe: yup
    .string()
    .required("Title in Telugu is required")
    .trim()
    .matches(
      /^[\u0C00-\u0C7F0-9\s!@#$%^&*()_+\-=\[\]{};:"\\|,.<>\/?]*$/,
      "Title in Telugu should only contain Telugu alphabets"
    ),

  titleKn: yup
    .string()
    .required("Title in Kannada is required")
    .trim()
    .matches(
      /^[\u0C80-\u0CFF0-9\s!@#$%^&*()_+\-=\[\]{};:"\\|,.<>\/?]*$/,
      "Title in Kannada should only contain Kannada alphabets"
    ),

  titleMr: yup
    .string()
    .required("Title in Marathi is required")
    .trim()
    .matches(
      /^[\u0900-\u097F0-9\s!@#$%^&*()_+\-=\[\]{};:"\\|,.<>\/?]*$/,
      "Title in Marathi should only contain Marathi alphabets"
    ),

  titleGu: yup
    .string()
    .required("Title in Gujarati is required")
    .trim()
    .matches(
      /^[\u0A80-\u0AFF0-9\s!@#$%^&*()_+\-=\[\]{};:"\\|,.<>\/?]*$/,
      "Title in Gujarati should only contain Gujarati alphabets"
    ),
  bannerType: yup.string().trim().required("Banner Type is required"),

  redirectTo: yup
    .string()
    .nullable()
    .when("bannerType", {
      is: "redirect",
      then: (schema) => schema.required("Required"),
      otherwise: (schema) => schema.nullable(),
    }),
  jobIdd: yup
    .string()
    .nullable()
    .when("redirectTo", {
      is: "JOB_DETAIL",
      then: (schema) => schema.required("JobId is required"),
      otherwise: (schema) => schema.nullable(),
    }),
  linkk: yup
    .string()
    .nullable()
    .when("redirectTo", {
      is: "LINK",
      then: (schema) => schema.required("Link is required"),
      otherwise: (schema) => schema.nullable(),
    }),
  bodyEn: yup
    .string()
    .required("Body in english is required")
    .trim()
    .matches(
      /^[A-Za-z0-9\s!@#$%^&*()_+\-=\[\]{};:"\\|,.<>\/?]*$/,
      "Body in english should only contain alphabets"
    ),
  bodyHi: yup
    .string()
    .required("Body in Hindi is required")
    .trim()
    .matches(
      /^[\u0900-\u097F0-9\s!@#$%^&*()_+\-=\[\]{};:"\\|,.<>\/?]*$/,
      "Body in hindi should only contain Hindi alphabets"
    ),
  bodyHn: yup
    .string()
    .required("Body in hinglish is required")
    .trim()
    .matches(
      /^[A-Za-z0-9\s!@#$%^&*()_+\-=\[\]{};:"\\|,.<>\/?]*$/,
      "Body in hinglish should only contain alphabets"
    ),

  bodyBn: yup
    .string()
    .required("Body in Bengali is required")
    .trim()
    .matches(
      /^[\u0980-\u09FF0-9\s!@#$%^&*()_+\-=\[\]{};:"\\|,.<>\/?]*$/,
      "Body in Bengali should only contain Bengali alphabets"
    ),

  bodyTa: yup
    .string()
    .required("Body in Tamil is required")
    .trim()
    .matches(
      /^[\u0B80-\u0BFF0-9\s!@#$%^&*()_+\-=\[\]{};:"\\|,.<>\/?]*$/,
      "Body in Tamil should only contain Tamil alphabets"
    ),

  bodyTe: yup
    .string()
    .required("Body in Telugu is required")
    .trim()
    .matches(
      /^[\u0C00-\u0C7F0-9\s!@#$%^&*()_+\-=\[\]{};:"\\|,.<>\/?]*$/,
      "Body in Telugu should only contain Telugu alphabets"
    ),

  bodyKn: yup
    .string()
    .required("Body in Kannada is required")
    .trim()
    .matches(
      /^[\u0C80-\u0CFF0-9\s!@#$%^&*()_+\-=\[\]{};:"\\|,.<>\/?]*$/,
      "Body in Kannada should only contain Kannada alphabets"
    ),

  bodyMr: yup
    .string()
    .required("Body in Marathi is required")
    .trim()
    .matches(
      /^[\u0900-\u097F0-9\s!@#$%^&*()_+\-=\[\]{};:"\\|,.<>\/?]*$/,
      "Body in Marathi should only contain Marathi alphabets"
    ),

  bodyGu: yup
    .string()
    .required("Body in Gujarati is required")
    .trim()
    .matches(
      /^[\u0A80-\u0AFF0-9\s!@#$%^&*()_+\-=\[\]{};:"\\|,.<>\/?]*$/,
      "Body in Gujarati should only contain Gujarati alphabets"
    ),
  // ctaButtonText: yup.string().trim().required("Button text is required"),

  ctaButtonTextEn: yup
    .string()
    .trim()
    .when("bannerType", {
      is: (val) => val !== "boolean",
      then: (schema) =>
        schema
          .required("Button text in English is required")
          .matches(
            /^[A-Za-z0-9\s!@#$%^&*()_+\-=\[\]{};:"\\|,.<>\/?]*$/,
            "Button text in English should only contain English alphabets"
          ),
      otherwise: (schema) =>
        schema
          .notRequired()
          .nullable()
          .test(
            "valid-if-present",
            "Button text in English should only contain English alphabets",
            (value) =>
              !value ||
              /^[A-Za-z0-9\s!@#$%^&*()_+\-=\[\]{};:"\\|,.<>\/?]*$/.test(value)
          ),
    }),

  ctaButtonTextHi: yup
    .string()
    .trim()
    .when("bannerType", {
      is: (val) => val !== "boolean",
      then: (schema) =>
        schema
          .required("Button text in Hindi is required")
          .matches(
            /^[\u0900-\u097F0-9\s!@#$%^&*()_+\-=\[\]{};:"\\|,.<>\/?]*$/,
            "Button text in Hindi should only contain Hindi alphabets"
          ),
      otherwise: (schema) =>
        schema
          .notRequired()
          .nullable()
          .test(
            "valid-if-present",
            "Button text in Hindi should only contain Hindi alphabets",
            (value) =>
              !value ||
              /^[\u0900-\u097F0-9\s!@#$%^&*()_+\-=\[\]{};:"\\|,.<>\/?]*$/.test(value)
          ),
    }),

  ctaButtonTextHn: yup
    .string()
    .trim()
    .when("bannerType", {
      is: (val) => val !== "boolean",
      then: (schema) =>
        schema
          .required("Button text in Hinglish is required")
          .matches(
            /^[A-Za-z0-9\s!@#$%^&*()_+\-=\[\]{};:"\\|,.<>\/?]*$/,
            "Button text in Hinglish should only contain alphabets"
          ),
      otherwise: (schema) =>
        schema
          .notRequired()
          .nullable()
          .test(
            "valid-if-present",
            "Button text in Hinglish should only contain alphabets",
            (value) =>
              !value ||
              /^[A-Za-z0-9\s!@#$%^&*()_+\-=\[\]{};:"\\|,.<>\/?]*$/.test(value)
          ),
    }),

  ctaButtonTextBn: yup
    .string()
    .trim()
    .when("bannerType", {
      is: (val) => val !== "boolean",
      then: (schema) =>
        schema
          .required("Button text in Bengali is required")
          .matches(
            /^[\u0980-\u09FF0-9\s!@#$%^&*()_+\-=\[\]{};:"\\|,.<>\/?]*$/,
            "Button text in Bengali should only contain Bengali alphabets"
          ),
      otherwise: (schema) =>
        schema
          .notRequired()
          .nullable()
          .test(
            "valid-if-present",
            "Button text in Bengali should only contain Bengali alphabets",
            (value) =>
              !value ||
              /^[\u0980-\u09FF0-9\s!@#$%^&*()_+\-=\[\]{};:"\\|,.<>\/?]*$/.test(value)
          ),
    }),

  ctaButtonTextTa: yup
    .string()
    .trim()
    .when("bannerType", {
      is: (val) => val !== "boolean",
      then: (schema) =>
        schema
          .required("Button text in Tamil is required")
          .matches(
            /^[\u0B80-\u0BFF0-9\s!@#$%^&*()_+\-=\[\]{};:"\\|,.<>\/?]*$/,
            "Button text in Tamil should only contain Tamil alphabets"
          ),
      otherwise: (schema) =>
        schema
          .notRequired()
          .nullable()
          .test(
            "valid-if-present",
            "Button text in Tamil should only contain Tamil alphabets",
            (value) =>
              !value ||
              /^[\u0B80-\u0BFF0-9\s!@#$%^&*()_+\-=\[\]{};:"\\|,.<>\/?]*$/.test(value)
          ),
    }),

  ctaButtonTextTe: yup
    .string()
    .trim()
    .when("bannerType", {
      is: (val) => val !== "boolean",
      then: (schema) =>
        schema
          .required("Button text in Telugu is required")
          .matches(
            /^[\u0C00-\u0C7F0-9\s!@#$%^&*()_+\-=\[\]{};:"\\|,.<>\/?]*$/,
            "Button text in Telugu should only contain Telugu alphabets"
          ),
      otherwise: (schema) =>
        schema
          .notRequired()
          .nullable()
          .test(
            "valid-if-present",
            "Button text in Telugu should only contain Telugu alphabets",
            (value) =>
              !value ||
              /^[\u0C00-\u0C7F0-9\s!@#$%^&*()_+\-=\[\]{};:"\\|,.<>\/?]*$/.test(value)
          ),
    }),

  ctaButtonTextKn: yup
    .string()
    .trim()
    .when("bannerType", {
      is: (val) => val !== "boolean",
      then: (schema) =>
        schema
          .required("Button text in Kannada is required")
          .matches(
            /^[\u0C80-\u0CFF0-9\s!@#$%^&*()_+\-=\[\]{};:"\\|,.<>\/?]*$/,
            "Button text in Kannada should only contain Kannada alphabets"
          ),
      otherwise: (schema) =>
        schema
          .notRequired()
          .nullable()
          .test(
            "valid-if-present",
            "Button text in Kannada should only contain Kannada alphabets",
            (value) =>
              !value ||
              /^[\u0C80-\u0CFF0-9\s!@#$%^&*()_+\-=\[\]{};:"\\|,.<>\/?]*$/.test(value)
          ),
    }),

  ctaButtonTextMr: yup
    .string()
    .trim()
    .when("bannerType", {
      is: (val) => val !== "boolean",
      then: (schema) =>
        schema
          .required("Button text in Marathi is required")
          .matches(
            /^[\u0900-\u097F0-9\s!@#$%^&*()_+\-=\[\]{};:"\\|,.<>\/?]*$/,
            "Button text in Marathi should only contain Marathi alphabets"
          ),
      otherwise: (schema) =>
        schema
          .notRequired()
          .nullable()
          .test(
            "valid-if-present",
            "Button text in Marathi should only contain Marathi alphabets",
            (value) =>
              !value ||
              /^[\u0900-\u097F0-9\s!@#$%^&*()_+\-=\[\]{};:"\\|,.<>\/?]*$/.test(value)
          ),
    }),

  ctaButtonTextGu: yup
    .string()
    .trim()
    .when("bannerType", {
      is: (val) => val !== "boolean",
      then: (schema) =>
        schema
          .required("Button text in Gujarati is required")
          .matches(
            /^[\u0A80-\u0AFF0-9\s!@#$%^&*()_+\-=\[\]{};:"\\|,.<>\/?]*$/,
            "Button text in Gujarati should only contain Gujarati alphabets"
          ),
      otherwise: (schema) =>
        schema
          .notRequired()
          .nullable()
          .test(
            "valid-if-present",
            "Button text in Gujarati should only contain Gujarati alphabets",
            (value) =>
              !value ||
              /^[\u0A80-\u0AFF0-9\s!@#$%^&*()_+\-=\[\]{};:"\\|,.<>\/?]*$/.test(value)
          ),
    }),




  expiryDateAndTime: yup
    .date()
    .min(new Date(), "Expiry date should not be previous date")
    .required("Expiry Date and Time is required"),
});


export const thirdFormBannerValidationSchema2 = yup.object().shape({

  tagImage: yup
    .mixed()
    .required("Image is required")
    .test("fileSize", "File size is too large", (value) => {
      if (value && value[0]) {
        return value[0].size <= 2 * 1024 * 1024; // 2MB
      }
      return true; // If no file is selected, return true
    })
    .test("fileType", "Unsupported file format", (value) => {
      if (value && value[0]) {
        const supportedFormats = ["image/jpeg", "image/png", "image/jpg"];
        return supportedFormats.includes(value[0].type);
      }
      return true; // If no file is selected, return true
    }),
  bannerType: yup.string().trim().required("Banner Type is required"),

  redirectTo: yup
    .string()
    .nullable()
    .when("bannerType", {
      is: "redirect",
      then: (schema) => schema.required("Required"),
      otherwise: (schema) => schema.nullable(),
    }),
  jobIdd: yup
    .string()
    .nullable()
    .when("redirectTo", {
      is: "JOB_DETAIL",
      then: (schema) => schema.required("JobId is required"),
      otherwise: (schema) => schema.nullable(),
    }),
  // linkk: yup
  //   .string()
  //   .nullable()
  //   .when("redirectTo", {
  //     is: "LINK",
  //     then: (schema) => schema.required("Link is required"),
  //     otherwise: (schema) => schema.nullable(),
  //   }),

  linkk: yup
    .string()
    .nullable()
    .when("redirectTo", {
      is: "LINK",
      then: (schema) =>
        schema
          .required("Link is required")
          .url("Enter a valid URL"),
      otherwise: (schema) =>
        schema
          .nullable()
          .notRequired()
          .test("is-valid-url-if-present", "Enter a valid URL", function (value) {
            if (!value) return true; // allow null or empty
            return yup.string().url().isValidSync(value); // validate format
          }),
    }),

  // ctaButtonText: yup.string().trim().required("Button text is required"),


  expiryDateAndTime: yup
    .date()
    .min(new Date(), "Expiry date should not be previous date")
    .required("Expiry Date and Time is required"),
});

export const createLinkValidatonSchema = yup.object().shape({
  title: yup
    .string()
    .required("Title  is required")
    .trim()
    .matches(
      /^[A-Za-z0-9\s!@#$%^&*()_+\-=\[\]{};:"\\|,.<>\/?]*$/,
      "Title only contain alphabets"
    ),
  link: yup
    .string()
    .required("Link is required")
    .trim()
    .matches(
      /^[A-Za-z0-9\s!@#$%^&*()_+\-=\[\]{};:"\\|,.<>\/?]*$/,
      "Title only contain alphabets"
    ),
})


export const CreateJobLocationValidationSchema = yup.object().shape({
  cityName: yup.string().trim().required("City Name is required"),
  metaTitle: yup.string().trim().required("Meta Title is required"),
  metaDescription: yup.string().trim().required("Meta Description is required"),
  mapUrl: yup.string().optional(),
  // content: yup.string().trim().required("Content is required"),
  cityInitial: yup.string().trim().required("City Initials is required"),
});
export const CreateAddonValidationSchema = yup.object().shape({
  discountPercentage: yup
    .number()
    .typeError("Discount must be a number")
    .required("Discount is required")
    .min(0, "Discount cannot be negative")
    .max(100, "Discount cannot exceed 100"),

  extraCredit: yup
    .string()
    .trim()
    .required("Extra credits is required")
    .matches(/^\d+$/, "Extra credits must be an integer"),
  hcCredit: yup
    .string()
    .trim()
    .required("Hiring credits is required")
    .matches(/^\d+$/, "Hiring credits must be an integer")
    .test("is-positive", "Hiring credits must be greater than 0", value => parseInt(value, 10) > 0),

  amount: yup
    .string()
    .trim()
    .required("Amount is required")
    .matches(/^\d+$/, "Amount must be an integer")
    .test("is-positive", "Amount must be greater than 0", value => parseInt(value, 10) > 0),

  expiryDuration: yup
    .string()
    .trim()
    .required("Expiry Duration is required")
    .matches(/^\d+$/, "Expiry Duration must be an integer"),
  addonPackName: yup
    .string()
    .trim()
    .required("Pack name is required"),
  type: yup
    .string()
    .required("Type is required"),
});

export const CreateMappingValidationSchema = yup.object().shape({

  region_id: yup
    .string()
    .required("Region is required"),
  form_id: yup
    .string()
    .required("Role is required"),
  phc: yup
    .number()
    .typeError("PHC must be a number")
    .integer("PHC must be a whole number")
    .min(0, "PHC cannot be negative")
    .required("PHC is required"),

});

export const CreateRegionValidationSchema = yup.object().shape({
  name: yup
    .string()
    .trim()
    .required("Region Name is required"),
  isActive: yup.boolean(),
  coordinates: yup
    .string()
    .required("Coordinates are required")
    .test(
      "valid-json-coordinates",
      "Invalid coordinates format",
      function (value) {
        if (!value || value.trim() === "") {
          return this.createError({ message: "Coordinates are required" });
        }

        // Try to parse JSON
        let parsed;
        try {
          parsed = JSON.parse(value);
        } catch (err) {
          return this.createError({ message: "Coordinates must be valid JSON format" });
        }

        // Check if it's an array
        if (!Array.isArray(parsed)) {
          return this.createError({ message: "Coordinates must be an array" });
        }

        if (parsed.length === 0) {
          return this.createError({ message: "Coordinates array cannot be empty" });
        }

        // Determine if it's single polygon or MultiPolygon
        // Single Polygon: [[lng, lat], [lng, lat], ...]
        // MultiPolygon: [[[[lng, lat], ...]], [[[lng, lat], ...]]]]

        const isMultiPolygon = Array.isArray(parsed[0]) && Array.isArray(parsed[0][0]) && Array.isArray(parsed[0][0][0]);

        if (isMultiPolygon) {
          // Validate MultiPolygon format with rings
          if (parsed.length < 1) {
            return this.createError({ message: "At least 1 polygon is required" });
          }

          for (let polyIndex = 0; polyIndex < parsed.length; polyIndex++) {
            const polygon = parsed[polyIndex];

            if (!Array.isArray(polygon)) {
              return this.createError({ message: `Polygon at index ${polyIndex + 1} must be an array` });
            }

            if (polygon.length < 1) {
              return this.createError({ message: `Polygon at index ${polyIndex + 1} must have at least one ring` });
            }

            // Validate each ring in the polygon
            for (let ringIndex = 0; ringIndex < polygon.length; ringIndex++) {
              const ring = polygon[ringIndex];

              if (!Array.isArray(ring)) {
                return this.createError({ message: `Ring at index ${ringIndex + 1} in polygon ${polyIndex + 1} must be an array` });
              }

              if (ring.length < 4) {
                return this.createError({ message: `Ring at index ${ringIndex + 1} in polygon ${polyIndex + 1} must have at least 4 coordinate pairs` });
              }

              // Validate each coordinate in the ring
              for (let i = 0; i < ring.length; i++) {
                const coord = ring[i];

                if (!Array.isArray(coord)) {
                  return this.createError({ message: `Coordinate at position ${i + 1} in ring ${ringIndex + 1} of polygon ${polyIndex + 1} must be an array` });
                }

                if (coord.length !== 2) {
                  return this.createError({ message: `Coordinate at position ${i + 1} in ring ${ringIndex + 1} of polygon ${polyIndex + 1} must have exactly 2 values [longitude, latitude]` });
                }

                const [lng, lat] = coord;

                if (typeof lng !== 'number' || typeof lat !== 'number') {
                  return this.createError({ message: `Coordinate at position ${i + 1} in ring ${ringIndex + 1} of polygon ${polyIndex + 1} must contain numbers` });
                }

                if (isNaN(lng) || isNaN(lat)) {
                  return this.createError({ message: `Coordinate at position ${i + 1} in ring ${ringIndex + 1} of polygon ${polyIndex + 1} contains invalid numbers` });
                }

                if (lng < -180 || lng > 180) {
                  return this.createError({ message: `Longitude at position ${i + 1} in ring ${ringIndex + 1} of polygon ${polyIndex + 1} must be between -180 and 180` });
                }

                if (lat < -90 || lat > 90) {
                  return this.createError({ message: `Latitude at position ${i + 1} in ring ${ringIndex + 1} of polygon ${polyIndex + 1} must be between -90 and 90` });
                }
              }
            }
          }
        } else {
          // Validate single Polygon format
          if (parsed.length < 4) {
            return this.createError({ message: "At least 4 coordinate pairs are required for a polygon" });
          }

          for (let i = 0; i < parsed.length; i++) {
            const coord = parsed[i];

            if (!Array.isArray(coord)) {
              return this.createError({ message: `Coordinate at position ${i + 1} must be an array` });
            }

            if (coord.length !== 2) {
              return this.createError({ message: `Coordinate at position ${i + 1} must have exactly 2 values [longitude, latitude]` });
            }

            const [lng, lat] = coord;

            if (typeof lng !== 'number' || typeof lat !== 'number') {
              return this.createError({ message: `Coordinate at position ${i + 1} must contain numbers` });
            }

            if (isNaN(lng) || isNaN(lat)) {
              return this.createError({ message: `Coordinate at position ${i + 1} contains invalid numbers` });
            }

            if (lng < -180 || lng > 180) {
              return this.createError({ message: `Longitude at position ${i + 1} must be between -180 and 180` });
            }

            if (lat < -90 || lat > 90) {
              return this.createError({ message: `Latitude at position ${i + 1} must be between -90 and 90` });
            }
          }
        }

        return true;
      }
    ),
});